// directives/copy.js
import Clipboard from 'clipboard';
import { Message } from 'element-ui';
export default {
  bind(el, binding) {
    const clipboard = new Clipboard(el, {
      text: () => binding.value || el.innerText,
    });

    clipboard.on('success', () => {
      Message.success('复制成功！');
    });

    clipboard.on('error', () => {
      Message.error('复制失败，请手动复制');
    });

    el._clipboard = clipboard; // 存储实例以便销毁
  },
  unbind(el) {
    el._clipboard?.destroy(); // 防止内存泄漏
  },
};